// extracted by mini-css-extract-plugin
export default {"title":"cMl2YdES","mobile":"mobile"};